require('../../modules/es6.object.create');
var $Object = require('../../modules/_core').Object;
module.exports = function create(P, D) {
  return $Object.create(P, D);
};



//////////////////
// WEBPACK FOOTER
// ./~/react-input-calendar/~/core-js/library/fn/object/create.js
// module id = 1251
// module chunks = 3